import { UPLOAD_IMAGE_URL, UPLOAD_ERROR, UPLOAD_IMAGE_DIMENSIONS, EXPERIMENT_DATA } from '../constants/actionTypes';

/**
 * Action that is dispatched when the experiment data needs to be updated.
 * @param  {String} experiment_data The experiment object provided by AB Testing framework.
 * @return {Object}
 */
export function setExperimentData(experimentData) {
  return {
    type: EXPERIMENT_DATA,
    experimentData,
  };
}

/**
 * Action that is dispatched when the image Url data needs to be updated.
 * @param  {String} imageUrl The image object url the user uploaded.
 * @return {Object}
 */
export function uploadImageUrl(imageUrl) {
  return {
    type: UPLOAD_IMAGE_URL,
    imageUrl,
  };
}

/**
 * Action that is dispatched when the error code needs to be updated.
 * @param  {String} errorCode The error code that the component will match and show.
 * @return {Object}
 */
export function setError(errorCode) {
  return {
    type: UPLOAD_ERROR,
    errorCode,
  };
}

/**
 * Action that sets an object containing the dimensions of the uploaded image.
 * @param {Object} dimensions
 * @property {Number} width
 * @property {Number} height
 * @return {Object}
 * @property {String} type  `UPLOAD_IMAGE_DIMENSIONS` constant
 * @property {Object} value The `dimensions` parameter
 */
export function setImageDimensions(dimensions) {
  return {
    type: UPLOAD_IMAGE_DIMENSIONS,
    value: dimensions,
  };
}



// WEBPACK FOOTER //
// ./src/actions/upload.js